import { truncate } from "@faire/web--source/common/truncate";
export var truncatePath = function(path) {
    if (!path) {
        return path;
    }
    return truncate(path, 50, "[...]");
};
